import { FC } from "react"
import { TimezoneSetting } from "../../../../module/settings/containers/timezone/setting"

export const TimezoneSettingPage: FC = () => <TimezoneSetting />
